export const navigation: NavigationItem[] = [
  {
    path: '/locations',
    labelKey: 'NAVIGATION.LOCATIONS',
    icon: 'location_on'
  },{
    path: '/lockers',
    labelKey: 'NAVIGATION.LOCKERS',
    icon: 'inventory_2'
  },{
    path: '/parcels',
    labelKey: 'NAVIGATION.PARCELS',
    icon: 'local_shipping'
  },
  // {
  //   path: '/users',
  //   labelKey: 'NAVIGATION.USERS',
  //   icon: 'people'
  // }
]

export interface NavigationItem {
  path: string;
  labelKey: string;
  icon?: string;
}
